export const formatBuildDate = buildDate => {
  if (!buildDate) {
    return undefined;
  }

  const parsedDate = new Date(buildDate);
  if (Number.isNaN(parsedDate.getTime())) {
    return undefined;
  }

  const day = String(parsedDate.getUTCDate()).padStart(2, "0");
  const month = String(parsedDate.getUTCMonth() + 1).padStart(2, "0");
  const year = parsedDate.getUTCFullYear();

  return `${day}/${month}/${year}`;
};

export const getBuildTitle = buildDate => {
  const formattedDate = formatBuildDate(buildDate);
  return formattedDate ? `Build: ${formattedDate}` : undefined;
};
